import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TODAY } from 'cargo-chief-commons';
import { NoteType } from '@notes/note-list/note-list.component';
import { FeedbackInformation } from '@notes/note/note.component';

@Component({
	selector: 'app-add-note',
	templateUrl: './add-note.component.html',
})
export class AddNoteComponent {
	@Input() noteType = NoteType.CARRIER;
	@Input() searchTruckForm = null;
	@Input() name: string = null;
	@Input() createdDate: Date = TODAY().toDate();
	@Input() feedbackInformation: FeedbackInformation;
	@Input() showFeedback: boolean;
	@Input() id: string = null;
	@Input() supportId: string = null;
	@Input() active: boolean;
	@Input() origin: string = null;
	@Input() destination: string = null;
	@Input() truckLaneId: string = null;

	@Output() textAreaClicked: EventEmitter<any> = new EventEmitter();
	@Output() cancelClicked: EventEmitter<any> = new EventEmitter();
	@Output() noteAdded: EventEmitter<any> = new EventEmitter();
	@Output() feedbackAdded: EventEmitter<any> = new EventEmitter();

}
